export class ConnectAzureBackupApplicationsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonBackupServicePrincipalId",
            "baseName": "eonBackupServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "customerBackupApplicationId",
            "baseName": "customerBackupApplicationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "customerBackupServicePrincipalId",
            "baseName": "customerBackupServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "customerTenantId",
            "baseName": "customerTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "federatedManagedIdentityResourceId",
            "baseName": "federatedManagedIdentityResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentApplicationId",
            "baseName": "agentApplicationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "agentServicePrincipalId",
            "baseName": "agentServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "agentFederatedManagedIdentityResourceId",
            "baseName": "agentFederatedManagedIdentityResourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectAzureBackupApplicationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
